import { BusinessInfoLine } from '../../../MobileInvoiceView/InvoicesBusinessInfo/BusinessInfoLine';
import * as React from 'react';
export var BusinessEmail = function (_a) {
    var email = _a.email;
    return email ? (React.createElement(BusinessInfoLine, { dataHook: "business-email", verticalLayout: true, value: email })) : null;
};
//# sourceMappingURL=BusinessEmail.js.map